/**
 * Deep merge two JSON objects, replacing arrays instead of merging them
 * @param target - The target object to merge into
 * @param source - The source object to merge from
 * @returns A new merged object
 */
export function deepMerge(target: any, source: any): any {
  const result = {...target} as any;

  for (const key in source) {
    if (source.hasOwnProperty(key)) {
      const sourceValue = source[key];
      const targetValue = (target as any)[key];

      if (sourceValue === null || sourceValue === undefined) {
        // Replace with null/undefined from source
        (result as any)[key] = sourceValue;
      } else if (Array.isArray(sourceValue)) {
        // Replace arrays entirely (don't merge)
        (result as any)[key] = [...sourceValue];
      } else if (
        typeof sourceValue === 'object' &&
        typeof targetValue === 'object' &&
        targetValue !== null &&
        !Array.isArray(targetValue) &&
        isPlainObject(sourceValue) &&
        isPlainObject(targetValue)
      ) {
        // Recursively merge objects
        (result as any)[key] = deepMerge(targetValue, sourceValue);
      } else {
        // Replace primitive values
        (result as any)[key] = sourceValue;
      }
    }
  }

  return result;
}

/**
 * Check if a value is a plain object (not Date, RegExp, etc.)
 */
function isPlainObject(value: any): boolean {
  return (
    value != null &&
    typeof value === 'object' &&
    value.constructor === Object &&
    Object.getPrototypeOf(value) === Object.prototype
  );
}
